import { ActionIcon, Tooltip } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useLeadsContainerStore, useLeadsStore } from "../../../../stores/LeadsStore";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReloadButton = ({ container, isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);
  const setLoadingJobs = useLeadsStore((s) => s.setLoadingJobs);

  const handleClick = () => {
    setReloadAll(true)
    setLoadingJobs(true)
  }

  return (
    <Tooltip label={lang.prm.container.refresh}>
      <ActionIcon
        onClick={handleClick}
        disabled={container?.loading}
        variant="subtle"
        mih={0}
        size={"lg"}
        ml={isMobile ? "auto" : undefined}
      >
        <IconRefresh size={22} />
      </ActionIcon>
    </Tooltip>
  );
};

export default ReloadButton;
